<template>
    <div>
        <link href="https://img2.233.com/wx/union/pc/fine/category/css/aq.css" rel="stylesheet" type="text/css">
        <div class="wx-header-cont" id="wx-header-cont"> 
        <!-- 添加white-skin白色皮肤，去掉既黑色皮肤 -->
        <div class="wx-header-container">
            <div class="fl-box">
          <h1 class="logo"> <a href="/"><img  :src="logo" > </a> </h1>
            <div class="line"></div>
            <div class="wx-subject">
                <h2>安全工程师</h2>
                <i class="dropdown-arrow"></i>
                <div class="subject-list">
                        <a href="./#/jianli">监理工程师</a>
                        <a href="./#/aq">安全工程师</a>
                        <a href="./#/cfe">一级消防工程师</a>
                        <a href="./#/zaojia">造价工程师</a>
                        <a href="./#/jzs1">一级建造师</a>
                        <a href="./#/jzs2">二级建造师</a>
                        <a href="./#/zjy">二级造价工程师</a>
                        <a href="./#/zjxfy">消防设施操作员</a>
                </div>
            </div>
            <div class="head-area  text-gry6 font14 fl m-t-10"  style="display: none;"> 当前地区
                <p class="m-l-15  bg-white fr "><em class="now-area p-0-20">全国版</em><a href="" class="more-area p-0-10">更多地区 </a></p>
                <div class="area_list">
                <ul>
                    <li><a href="/tegang/guojia/#tgtc">全国</a></li>
                    <li><a href="/tegang/shanxi1/#tgtc">陕西</a></li>
                    <li><a href="/tegang/hebei/#tgtc">河北</a></li>
                    <li><a href="/tegang/henan/">河南</a></li>
                    <li><a href="/tegang/sichuan/#tgtc">四川</a></li>
                    <li><a href="/tegang/jiangxi/#tgtc">江西</a></li>
                    <li><a href="/tegang/yunnan/#tgtc">云南</a></li>
                    <li><a href="/tegang/heilongjiang/#tgtc">黑龙江</a></li>
                    <li><a href="/tegang/chongqing/#tgtc">重庆</a></li>
                    <li><a href="/tegang/hubei/#tgtc">湖北</a></li>
                </ul>
                </div>
            </div>
            </div>
            <div class="fr-box"> 
                <!--未登录 -->
                <div class="personal-no" v-if="!isLogin">
                    <p><a target="_blank" :href="'/uc/login?redirecturl='+href" class="red">登录</a>|<a target="_blank" :href="'/uc/register?redirecturl='+href">注册</a></p>
                </div>
                <div class="personal" v-else>
                            <a href="javascript:;" class="pic"><img :src="logoSrc" ><i class="dropdown-arrow"></i></a>
                            <div class="pop-personal">
                                <a href="javascript:" @click="loginout()"><i class="icon"></i><span class="txt">退出</span></a>
                            </div>
                </div>
                <div class="classify"> 
                    <a class="classify-list" href="/shopping/cart" target="_blank" title="购课车">
                    <p class="icon shopping"></p>
                    </a> </div>
                <div v-if="kefu.length>0" class="wx-telephone">
                    <p class="txt1">客服热线</p>
                    <p class="txt2">{{kefu}}</p>
                </div>
            </div>
        </div>
        <div class="clear"></div>
        </div>
        <!--banner-->
        <div class="bg-black"> 
        <!--01banner-->
        <Banner imgUrl="https://img2.233.com/wx/union/pc/fine/category/img/aq/banner01.jpg"></Banner>
        <!--01banner 结束--> 
        <!---02试听区域--->
        <div class="video clearfix">
            <div class="video-layout">
            <div class="subject-tabBox clearfix" >
                <ul class="sub-tabL clearfix">
                <li class="line" @click="changeCourseIndex(i)" v-for="(v,i) in courses.slice(0,6)" :key="i">
                    <a href="javascript: void(0)"  :class="i==courseIndex?'hover':''">{{v.name}}</a>
                </li>
                </ul>
                <div class="Rselect-box" @mouseover="changeIsHoverCourse(true)" @mouseout="changeIsHoverCourse(false)" >
                <p class="subject-select currt clearfix"><span class="txt">选择其它科目</span><i class="ico"></i></p>
                <div class="sub-sel-list" v-show="isHoverCourse">
                    <ul>
                    <li v-for="(v,i) in courses.slice(6)" :key="i">
                        <a  @click="changeCourseIndex(i+4)" style="text-overflow:ellipsis; overflow:hidden; white-space:nowrap;" href="javascript: void(0)">{{v.name}}</a>
                    </li>
                    </ul>
                </div>
                </div>
            </div>
            <myvideo   :isLogin="isLogin"  :allLoginPlayFlag="allLoginPlayFlag"  :unionId="unionId" :classEname="'jzs2'" :logo="logo" :myClassId="courses[courseIndex].myClassId"></myvideo>
            </div>
            <div class="video-bottom"></div>
        </div>
        <!---02试听区域END---> 
        </div>
        <!--03原高级平台班级对比-->
        <banjiduibi :calssName="'安全工程师'" :classEName="'aq'"></banjiduibi>
        <!--03原高级平台班级对比 end--> 
            
        <!--04全部班级表格-->
        <quanbubanji :classEname="'aq'"></quanbubanji>
        <!--04全部班级表格 end--> 


        <!-- 购课保障 -->
        <div class="aq_kcbz_k">
        
        <div class="aqkcbz_center">
            <div class="title-bg">
            <a name="sktx"></a>
            <h3 class="h3-title layout-box"> <i class="title-ico"></i> <span class="title-txt f-white"> <span class="h1">购课保障</span><br>
                <span class="h2">报名网校中级安全工程师高端班你能获得什么权益？有什么具体收获？</span> </span>
            </h3>
            </div>
        
        <div class="aqkcbz_center_nr clearfix">
                <div class="aqkcbz_left clearfix">
                <h3>权益</h3>
                
            <div class="aq_kcbzl_md1">
                <h4 class="kcbzl_tit">
                    学习保障
                </h4>
                
                <p>① 2个考期内无限制自由学</p>
                <p>② 电子版量身定制学习计划</p>
                </div>
            
                <div class="aq_kcbzl_md2">
                
                <h4 class="kcbzl_tit">
                在线题库
                </h4>
                
                <p>① 根据考情每章节计算分值比重
        依照分值针对性做题，省时高效。</p>
                <p>② 每道题均配有专业的答案解析，
        真正学透试题中包含的考点。</p>
                </div>
                
            
                <div class="aq_kcbzl_md3">
                
                    <h4 class="kcbzl_tit">
                后台答疑
                </h4>
                
                <p>网校设有专业答疑平台，学员提出疑问后，老师8小时内处理完毕。</p>
                
                </div>
                
                
                    </div>
            
            
            <div class="aqkcbz_right">
            
            <h3>收获</h3>
            
                <ul class="clearfix">
                    <li>
                    
                    <p>吃透4科教材考点<br><strong>掌握核心考点</strong></p>
                    <div class="aqkacbz_sj clearfix">
                        <span class="kcbz_num_left clearfix">85<b class="kcba_time">小时</b></span>
                    <h4 class="kcbz_num_right">50<a>%</a><i>提分</i></h4>
                    </div>
                </li>
                <li>
                    
                    <p>习题细分讲解<br><strong>掌握做题技巧</strong></p>
                    <div class="aqkacbz_sj clearfix">
                        <span class="kcbz_num_left">20<b class="kcba_time">小时</b></span>
                    <h4 class="kcbz_num_right">20<a>%</a><i>提分</i></h4>
                    </div>
                </li>
                <li>
                    
                    <p>高频考点全新整理串讲
        <br><strong>突破考试</strong></p>
                    <div class="aqkacbz_sj clearfix">
                        <span class="kcbz_num_left">25<b class="kcba_time">小时</b></span>
                    <h4 class="kcbz_num_right">20<a>%</a><i>提分</i></h4>
                    </div>
                </li>
                <li>
                    
                    <p>实务科目难点提炼讲解
        <br><strong>+自测查漏补缺</strong></p>
                    <div class="aqkacbz_sj clearfix">
                        <span class="kcbz_num_left">22<b class="kcba_time">小时</b></span>
                    <h4 class="kcbz_num_right">10<a>%</a><i>提分</i></h4>
                    </div>
                </li>
            </ul> 
            
            </div>      
            </div>
        
        
        
        </div>
            
        </div>
        <!-- 购课保障 end -->
        <!-- 证书价值 -->
        <div class="con03-box layout-box">
            <h3 class="h3-title">
            <a name="zsjz"></a> <i class="title-ico"></i> <span class="title-txt f-black"> <span class="h1">证书价值</span><br>
            <span class="h2">人证合一的时代，市场需求大，含金量高</span> </span>
            </h3>
            <ul class="ul-zsjz-box clearfix">
            <li> <span><img src="https://img2.233.com/wx/union/pc/fine/category/img/aq/zs-img01.png" alt="网校-中级安全工程师"></span> <span class="zs-strong">升职加薪 评职称</span>
                <p class="zs-txt">取得中级安全工程师证书薪资：施工单位的话如果是国企一般月薪至少6000+；有的单位每年会补5000到10000不等，<br>
        <span class="bluk">还可以直接评审中级职称。</span> </p>
            </li>
            <li class="zsjz-li02"> <span><img src="https://img2.233.com/wx/union/pc/fine/category/img/aq/zs-img02.png" alt="网校-中级安全工程师"></span> <span class="zs-strong">国家重视 市场需求大</span>
                <p class="zs-txt"> 相关专业技术服务机构明确注册安全工程师配备比例不低于30%；未来3-5年，安全工程师工程师人才缺口高达约100万，<span class="bluk">持证者势必成为行业新宠。</span></p>
            </li>
            <li> <span><img src="https://img2.233.com/wx/union/pc/fine/category/img/aq/zs-img03.png" alt="网校-中级安全工程师"></span> <span class="zs-strong">专业细分 难度大增</span>
                <p class="zs-txt">新政改革，分七大专业，含金量大大提升，因此考查知识点会更细、更实际，难度也会有所增长，<span class="bluk">想要在安全战场上挥洒自如，成功逆袭，你需要一份网校给你的辅导</span> </p>
            </li>
            </ul>
        </div>
        <!-- 证书价值 end-->
        <!-- 授课体系 -->
        <div class="con04-box">
            <div class="title-bg">
            <a name="sktx"></a>
            <h3 class="h3-title layout-box"> <i class="title-ico"></i> <span class="title-txt f-white"> <span class="h1">授课体系</span><br>
                <span class="h2">三大阶段快速提分，让考试变得更简单</span> </span>
            </h3>
            </div>
            <div class="sktx-layout layout-box">
            <div class="sktx-listBox">
                <div class="sktx-title clearfix"> <span class="sktx-title-l"></span>
                <div class="sktx-title-r"> <span class="tjbj-ico"></span>
                    <p class="bj-txt">零基础入门班+教材精讲班</p>
                    <span class="bj-js-box"> <span class="txt-l">360°吃透教材</span> <span class="bj-ks"> 全科课时约 <b>1</b> <b>5</b> <b>1</b>  </span> </span>
                </div>
                </div>
                <div class="sktx-bottom clearfix">
                <ul>
                    <li> <span class="sktx-list-dbx">梳理<br>
                    教材
                    </span>
                    <p class="sktx-list-dl">全面梳理教材，精讲全科440个重要考点</p>
                    <span class="link-ico"></span> </li>
                    <li class="sktx-list02"> <span class="sktx-list-dbx">速记<br>
                    考点</span>
                    <p class="sktx-list-dl">区分数据与相近概念，科学分类考点。</p>
                    <span class="link-ico"></span> </li>
                    <li> <span class="sktx-list-dbx">详解<br>
                    案例</span>
                    <p class="sktx-list-dl">详解典型案例，掌握考点出题形式。</p>
                    </li>
                </ul>
                </div>
            </div>
            <div class="sktx-listBox sktx-list02Box">
                <div class="sktx-title clearfix"> <span class="sktx-title-l"></span>
                <div class="sktx-title-r"> <span class="tjbj-ico"></span>
                    <p class="bj-txt">习题班+高频考点班+案例班</p>
                    <span class="bj-js-box"> <span class="txt-l">巩固重难点</span> <span class="bj-ks"> 全科课时约 <b>6</b> <b>8</b>  </span> </span>
                </div>
                </div>
                <div class="sktx-bottom clearfix">
                <ul>
                    <li> <span class="sktx-list-dbx">经典<br>
                    习题</span>
                    <p class="sktx-list-dl">习题班汇总上百道典型考题，教你答题“套路”。</p>
                    <span class="link-ico"></span> </li>
                    <li class="sktx-list02"> <span class="sktx-list-dbx">攻克<br>
                    难点</span>
                    <p class="sktx-list-dl">高频考点班攻克重难点，只为抓住核心分值。</p>
                    <span class="link-ico"></span> </li>
                    <li> <span class="sktx-list-dbx">专项<br>
                    突破</span>
                    <p class="sktx-list-dl">专项班以图文教学的特色模式，攻克实务难题。</p>
                    </li>
                </ul>
                </div>
            </div>
            <div class="sktx-listBox sktx-list03Box">
                <div class="sktx-title clearfix"> <span class="sktx-title-l"></span>
                <div class="sktx-title-r"> <span class="tjbj-ico"></span>
                    <p class="bj-txt">真题班+考题突击班+直播班</p>

                    <span class="bj-js-box"> <span class="txt-l">临考超速提分</span> <span class="bj-ks"> 全科课时约 <b>3</b> <b>5</b>  </span> </span>
                </div>
                </div>
                <div class="sktx-bottom clearfix">
                <ul>
                    <li> <span class="sktx-list-dbx">真题<br>
                    解析</span>
                    <p class="sktx-list-dl">真题班剖析历年真题，总结考试规律。</p>
                    <span class="link-ico"></span> </li>
                    <li class="sktx-list02"> <span class="sktx-list-dbx">模考<br>
                    考题</span>
                    <p class="sktx-list-dl">考题突击班精讲2套考题突击卷。</p>
                    <span class="link-ico"></span> </li>
                    <li> <span class="sktx-list-dbx">考前<br>
                    直播</span>
                    <p class="sktx-list-dl">直播班考前15天划重点，临考再提30分。</p>
                    </li>
                </ul>
                </div>
            </div>
            </div>
        </div>
        <!-- 授课体系 end -->
        <!-- 师资护航 -->
        <div class="con07_box_all"><div class="con07-box layout-box">
            <h3 class="h3-title">
            <a name="sztd"></a><i class="title-ico"></i> <span class="title-txt f-white"> <span class="h1">专业师资护航</span><br>
            <span class="h2">为你开启过关外挂模式</span> </span>
            </h3>
        <div class="careerbox"  id="teacher-list-main">
            <div class="teacher-cl" v-for="(v,i) in teachers" :key="i" v-show="teacherIndex==i">
                <div class="teacher-cl-left">
                    <img  :src="'https://img2.233.com/wx/union/pc/fine/category/img/aq/'+v.img">
                </div>
                <div class="teacher-cl-right">
                    <ul>
                        <li><strong>{{v.name}}</strong> <i>{{v.pinyin}}</i></li>
                        <li><p><em>老师资历：</em>{{v.zili}}</p></li>
                        <li><p><em>主讲课程：</em>{{v.kecheng}}</p> </li>
                        <li><p><em>授课特色：</em>{{v.tese}}</p></li>
                    </ul>
                </div>
            </div>
            <div class="teacher-team">
                <div class="teacher-box-tab">
                    <a class="T-btn-left" @click="changeTeacherIndexjian()" href="javascript:"></a>
                    <a class="T-btn-right" @click="changeTeacherIndexjia()"  href="javascript:"></a>
                    <div class="cont">
                        <ul style="width: 99999px; left: 0px;">
                        <li data-act="陈浩" @mouseover="changeTeacherIndex(0)" :class="teacherIndex==0?'action':''"> <img src="https://img2.233.com/wx/union/pc/fine/category/img/aq/ls_x_wjr.png"> </li>
                        <li data-act="金亮" @mouseover="changeTeacherIndex(1)" :class="teacherIndex==1?'action':''"> <img src="https://img2.233.com/wx/union/pc/fine/category/img/aq/ls_x_xr.png"> </li>
                        <li data-act="马庆华" @mouseover="changeTeacherIndex(2)"  :class="teacherIndex==2?'action':''"> <img src="https://img2.233.com/wx/union/pc/fine/category/img/aq/ls_x_mkl.png"> </li>
                        <li data-act="徐日勇" @mouseover="changeTeacherIndex(3)"  :class="teacherIndex==3?'action':''"> <img src="https://img2.233.com/wx/union/pc/fine/category/img/aq/ls_x_lsh.png"> </li>
                        </ul>
                    </div>
                </div>
            </div>
            </div>

        </div>
        </div>
        <!-- 师资护航 end -->
        <!--智能题库模块-->
        <div class="wx-course zhinneg_md" id="zntk">
            <div class="wx-mian clearfix"> 
                    <!--标题-->
                <h3 class="h3-title">
            <a name="zsjz"></a> <i class="title-ico"></i> <span class="title-txt f-black"> <span class="h1">智能题库</span><br>
            <span class="h2">专业智能，高效提分</span> </span>
            </h3>
                    <!--标题 end-->
                    <div class="zhineng_md_all clearfix"> 
                        <div class="zntk_md_left">
                                <h4>品质过硬</h4>
                            <ul class="znmd_left_ul clearfix">
                                    <li>
                                        <div class="znmk_md1 clearfix">
                                                <i class="znmd_icon znmd_img_1"></i>
                                                <div class="znmd_li_title">
                                                    <h5>专业解析</h5>
                                                    <p>每道题<font class="ft_bold">配有专业答案解析</font><br>解密题目背后的考点逻辑</p>
                                                </div>
                                        </div>
                                        <a>注：付费学员专享100%章节题量</a>
                                    </li>
                                    <li>
                                        <div class="znmk_md1 clearfix">
                                                <i class="znmd_icon znmd_img_2"></i>
                                                <div class="znmd_li_title">
                                                    <h5>助教答疑</h5>
                                                    <p>每道题<font class="ft_bold">专业助教答疑服务</font><br>做题不留任何疑问</p>
                                                </div>
                                        </div>
                                        <a class="znmd_a_bg2">注：付费学员专享</a>
                                    </li>
                                    <li class="bottom_pt18">
                                        <div class="znmk_md1 clearfix">
                                                <i class="znmd_icon znmd_img_3"></i>
                                                <div class="znmd_li_title">
                                                    <h5>模考大赛</h5>
                                                    <p>万名考生同场闯关做题<br><font class="ft_bold">并配套名师直播讲题</font></p>
                                                </div>
                                        </div>
                                    </li>
                                    <li class="bottom_pt18">
                                        <div class="znmk_md1 clearfix">
                                                <i class="znmd_icon znmd_img_6"></i>
                                                <div class="znmd_li_title">
                                                    <h5>大数据提分</h5>
                                                    <p>结合考情，分析章节分值<br><font class="ft_bold">大数据预判考点</font>，精准提分</p>
                                                </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        <div class="zntk_md_right">
                                <h4>智能系统</h4>  
                                <ul class="znmd_right_ul clearfix">
                                    <li class="znmd_rli    znmd_rli_bg1">
                                        <div class="znmdli_right_title">
                                                <h5>云计算</h5>
                                                <p>数百万用户高频错题<br><font class="ft_bold2">帮助避开常见失分点</font></p>
                                        </div> 
                                    </li>
                                    <li class="znmd_rli  color_blue   znmd_rli_bg2">
                                        <div class="znmdli_right_title">
                                                <h5>错题归纳</h5>
                                                <p>错题按章节和题型归类<br><font class="ft_bold2">智能汇总个人薄弱考点</font></p>
                                        </div> 
                                    </li>
                                    <li class="znmd_rli  color_blue   znmd_rli_bg3">
                                        <div class="znmdli_right_title">
                                                <h5>智能评分</h5>
                                                <p><font class="ft_bold2">系统根据做题数据智能评分</font><br>科学评测做题水准</p>
                                        </div> 
                                    </li>
                                    <li class="znmd_rli    znmd_rli_bg5">
                                        <div class="znmdli_right_title">
                                                <h5>离线做题</h5>
                                                <p>网校APP支持套题下载<br><font class="ft_bold2">随时随地免流量刷题</font></p>
                                        </div> 
                                    </li>
                                </ul>  
                        </div> 
                    </div>
                </div>
        </div>
        <!--智能题库模块 end-->
        <!--06套用官网内容  end-------------> 
        <!--05服务特色标题-->
        <div class="main-title f-tac m-b-30 p-t-50" >
            <p class="font-bg">CHARACTERISTIC</p>
            <h2 class="font44 fb">选择我们的<em class="text-red fb">四大理由</em></h2>
            <p class="font17 text-gry-6 lh2">服务保障，学习无忧，通关指日可待</p>
        </div>
        <div class="fuwu-bg ">
            <div class="fuwu-content">
                <div class="fuwu-box">
                    <ul class="clearfix m-b-20">
                        <li>
                        <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">1</span>课程品质高</h4>
                        <p class="font15 lh2 p-15">课程专业的教研团队精心打造，<em class="text-red fb">每个课程均经过20+次以上迭代</em>。</p>
                        </li>
                        <li>
                        <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">2</span>老师实力强</h4>
                        <p class="font15 lh2 p-15">网校执行严格的<em class="text-red fb">师资淘汰制，由购课学员评分</em>，努力建设零差评老师团队。</p>
                        </li>
                        <li>
                        <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">3</span>学习服务优</h4>
                        <p class="font15 lh2 p-15">您在学习课程中遇到任何问题，可在线提问，专业老师<em class="text-red fb">24小时内为您答疑解惑</em>。</p>
                        </li>
                        <li>
                        <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">4</span>售后服务好</h4>
                        <p class="font15 lh2 p-15">部分套餐课程享<em class="text-red fb">超长有效期</em>，课程有效期内考试<em class="text-red fb">不过免费重学</em>保障。</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!--05服务特色 end--> 
    </div>
</template>
<script>
import myvideo from '@/components/myvideo'
import banjiduibi from '@/components/banjiduibi'
import quanbubanji from '@/components/quanbubanji'
import { getMemberPicpath } from '@/request/request.js'
export default {
  name: 'App',
  components: {
    banjiduibi,
    quanbubanji,
    myvideo
  },  
  data() {
    return {
      laoshiindex:0,
      isLogin:false,
      logoSrc:"",
      allLoginPlayFlag:false,
      unionId:"",
      kefu:"",
      logo:"",
      href:"",
      courses:[
        {name:'安全生产法律法规',myClassId:31098},
        {name:'安全生产管理',myClassId:31099},
        {name:'煤矿安全',myClassId:31106},
        {name:'金属非金属矿山安全',myClassId:31105},
        {name:'化工安全',myClassId:31104},
        {name:'建筑施工安全',myClassId:31103},
        {name:'金属冶炼安全',myClassId:31107},
        {name:'其他安全(不含消防安全)',myClassId:31102},
        {name:'道路运输安全',myClassId:31108},
        {name:'安全生产技术基础',myClassId:31100},
      ],
      courseIndex:0,
      isHoverCourse:false,
      teachers:[
            {img:"ls_d_wjr.png",name:"陈浩",pinyin:"CHENHAO",zili:"高级工程师，安全工程师，一级建造师",kecheng:"安全生产法及相关法律知识",tese:"知识点归纳详细，紧扣考试大纲，把握考试方向。"},
            {img:"ls_d_xr.png",name:"江凌俊",pinyin:"JINLIANG",zili:"全国注册建造师、监理工程师、安全工程师",kecheng:"建筑施工安全",tese:"授课擅长“用通俗的语言解释专业，用形象的方法记忆考点”尤其擅长辅导零基础、非专业的学员。"},
            {img:"ls_d_mkl.png",name:"崔啊波",pinyin:"MAQINGHUA",zili:"安全工程师、学院派高级讲师",kecheng:"安全生产技术基础",tese:"思路清晰、擅长总结学习方法；剖析考点稳、准，安全技术的牛逼老师。"},
            {img:"ls_d_lsh.png",name:"徐日勇",pinyin:"XURIYONG",zili:"注册安全工程师，国家危险化学品评价师",kecheng:"安全生产专业实务",tese:"授课理念、方法与实践对照，风格幽默、不拘一格。"},
      ],
      teacherIndex:0,
    };
  },
  created(){
    this.href=encodeURIComponent(window.location.href);
    var config=JSON.parse(sessionStorage.getItem(window.location.host+"puconfig"));
    if(config.KefuTelList.length>0){
      this.kefu=config.KefuTelList[0].KefuNumber;
    }
    this.unionId=config.UnionId
    this.logo=config.UnionLogo;
    this.allLoginPlayFlag=config.AllLoginPlayFlag;
    var token = localStorage.getItem("usertoken");
    if(token!=undefined){
        this.isLogin=true;
        getMemberPicpath({},(res)=>{
            this.logoSrc=res;
        });
    }else{
        var interval= setInterval(() => {
        token = localStorage.getItem("usertoken");
        if(token!=undefined){
          this.isLogin=true;
          getMemberPicpath({},(res)=>{
            this.logoSrc=res;
          });
          clearInterval(interval);
        }
      }, 200);
    }
  },
  methods:{
      loginout(){
          this.isLogin=false;
          this.logoSrc="";
          localStorage.removeItem("usertoken");
      },
      scroll(num){
        document.documentElement.scrollTop=num;
      },
     changeCourseIndex(i){
       this.courseIndex=i;
     },
    changeIsHoverCourse(flag){
      this.isHoverCourse=flag;
    },
    changehoverindex(i){
      this.hoverindex=i;
    },
    changeTeacherIndex(i){
      this.teacherIndex=i;
    },
    changeTeacherIndexjia(){
      if(this.teacherIndex<3){
          this.teacherIndex++;
      }
    },
    changeTeacherIndexjian(){
        if(this.teacherIndex>0){
          this.teacherIndex--;
        }
    }
  },
}
</script>